function getSwiper(useLegacy) {
  if (typeof window === 'undefined') return null
  if (useLegacy && window.Swiper4) return window.Swiper4
  return window.Swiper || null
}

export function destroySwiper(instance) {
  if (instance && instance.destroy) {
    try { instance.destroy(true, true) } catch (e) { /* noop */ }
  }
}

export function initIndexDiv1(root, options = {}) {
  const Swiper = getSwiper(true) || getSwiper()
  if (!Swiper || !root) return null
  const el = root.querySelector('.swiper-container')
  if (!el) return null
  if (el.swiper && el.swiper.destroy) {
    try { el.swiper.destroy(true, true) } catch (e) { /* noop */ }
  }
  const config = {
    speed: 400,
    spaceBetween: 30,
    slidesPerView: options.slidesPerView || 4,
    slidesPerGroup: 1,
    allowTouchMove: false,
    simulateTouch: false,
    navigation: {
      nextEl: root.querySelector('.swiper-button-next'),
      prevEl: root.querySelector('.swiper-button-prev')
    },
    observer: true,
    observeParents: true,
    breakpoints: {
      1200: { slidesPerView: Math.min(options.slidesPerView || 6, 6), spaceBetween: 30 },
      992: { slidesPerView: 4, spaceBetween: 20 },
      768: { slidesPerView: 3, spaceBetween: 12 }
    }
  }
  if (typeof options.onSlideChange === 'function') {
    config.on = {
      slideChange: function () {
        options.onSlideChange(this)
      }
    }
  }
  return new Swiper(el, config)
}

export function initAboutDiv3(root) {
  const Swiper = getSwiper(true)
  if (!Swiper || !root) return null
  const el = root.querySelector('.swiper-container')
  if (!el) return null
  if (el.swiper && el.swiper.destroy) {
    try { el.swiper.destroy(true, true) } catch (e) { /* noop */ }
  }
  const slideCount = el.querySelectorAll('.swiper-wrapper > .swiper-slide').length
  if (!slideCount) return null
  const enableLoop = slideCount > 1
  const config = {
    speed: 800,
    loop: enableLoop,
    loopedSlides: enableLoop ? slideCount : 0,
    loopAdditionalSlides: enableLoop ? 2 : 0,
    spaceBetween: 10,
    navigation: {
      nextEl: root.querySelector('.swiper-button-next'),
      prevEl: root.querySelector('.swiper-button-prev')
    },
    autoplay: enableLoop ? { delay: 5000, disableOnInteraction: false } : false,
    observer: true,
    observeParents: true
  }
  return new Swiper(el, config)
}

export function initAboutDiv8(root) {
  const Swiper = getSwiper(true)
  if (!Swiper || !root) return null
  const el = root.querySelector('.swiper-container')
  if (!el) return null
  if (el.swiper && el.swiper.destroy) {
    try { el.swiper.destroy(true, true) } catch (e) { /* noop */ }
  }
  return new Swiper(el, {
    loop: true,
    slidesPerView: 'auto',
    initialSlide: 2,
    centeredSlides: true,
    effect: 'coverflow',
    grabCursor: true,
    coverflowEffect: {
      rotate: 40,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: false
    },
    navigation: {
      nextEl: root.querySelector('.swiper-button-next'),
      prevEl: root.querySelector('.swiper-button-prev')
    },
    observer: true,
    observeParents: true
  })
}

export function initAboutDiv9(root) {
  const Swiper = getSwiper()
  if (!Swiper || !root) return null
  const el = root.querySelector('.swiper-container')
  if (!el) return null
  return new Swiper(el, {
    speed: 800,
    spaceBetween: 10,
    slidesPerView: 3,
    slidesPerColumn: 2,
    slidesPerGroup: 1,
    pagination: {
      el: root.querySelector('.swiper-pagination'),
      clickable: true
    },
    navigation: {
      nextEl: root.querySelector('.swiper-button-next'),
      prevEl: root.querySelector('.swiper-button-prev')
    },
    autoplay: { delay: 5000 },
    observer: true,
    observeParents: true,
    breakpoints: { 1024: { slidesPerView: 2 } }
  })
}

/** Homepage industry solutions: gallery-top + gallery-thumbs */
export function initSolutionGallery(root) {
  const Swiper = getSwiper(true) || getSwiper()
  if (!Swiper || !root) return { thumbs: null, top: null }

  const thumbsEl = root.querySelector('.gallery-thumbs')
  const topEl = root.querySelector('.gallery-top')
  if (!thumbsEl || !topEl) return { thumbs: null, top: null }

  const slideCount = topEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length
  if (!slideCount) return { thumbs: null, top: null }

  ;[thumbsEl, topEl].forEach(el => {
    if (el.swiper && el.swiper.destroy) {
      try { el.swiper.destroy(true, true) } catch (e) { /* noop */ }
    }
  })

  // Explicit viewport count — avoid Swiper breakpoint quirks showing only 3
  const w = typeof window !== 'undefined' ? window.innerWidth : 1400
  let perView = 6
  if (w < 576) perView = 2
  else if (w < 768) perView = 3
  else if (w < 992) perView = 4
  else if (w < 1200) perView = 5
  perView = Math.min(perView, slideCount)

  const nextEl = root.querySelector('.smallDiv .swiper-button-next')
  const prevEl = root.querySelector('.smallDiv .swiper-button-prev')

  // Category strip: locked until left/right is clicked (1 card per click).
  // No drag / hover / observer — those were jumping the strip by many cards.
  const thumbs = new Swiper(thumbsEl, {
    spaceBetween: w >= 1200 ? 30 : w >= 768 ? 20 : 10,
    slidesPerView: perView,
    slidesPerGroup: 1,
    speed: 400,
    freeMode: false,
    allowTouchMove: false,
    simulateTouch: false,
    shortSwipes: false,
    longSwipes: false,
    followFinger: false,
    resistanceRatio: 0,
    watchOverflow: true,
    preventClicks: false,
    preventClicksPropagation: false
  })

  function moveThumbsBy(dir, e) {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    if (!thumbs) return
    if (dir > 0) thumbs.slideNext(400)
    else thumbs.slidePrev(400)
  }

  if (nextEl) {
    nextEl.onclick = function (e) { moveThumbsBy(1, e) }
  }
  if (prevEl) {
    prevEl.onclick = function (e) { moveThumbsBy(-1, e) }
  }

  // Fade background: hover/click category cards to switch (no autoplay)
  const top = new Swiper(topEl, {
    effect: 'fade',
    fadeEffect: { crossFade: true },
    speed: 350,
    spaceBetween: 0,
    allowTouchMove: false,
    simulateTouch: false,
    autoplay: false,
    on: {
      slideChange: function () {
        syncThumbActive(this.activeIndex)
      }
    }
  })

  function syncThumbActive(index) {
    try {
      const list = thumbsEl.querySelectorAll('.swiper-wrapper > .swiper-slide')
      list.forEach((el, i) => {
        // Only thumb highlight — never toggle swiper-slide-active (that shifts the strip)
        el.classList.toggle('swiper-slide-thumb-active', i === index)
      })
    } catch (e) { /* noop */ }
  }

  function selectSolution(index) {
    try { top.slideTo(index, 0) } catch (err) { /* noop */ }
    syncThumbActive(index)
    // Do NOT thumbs.slideTo — keep strip position; only arrows move it
  }

  const slides = thumbsEl.querySelectorAll('.swiper-wrapper > .swiper-slide')
  slides.forEach((slide, index) => {
    slide.onmouseenter = function () { selectSolution(index) }
    slide.onmouseover = null
    slide.onmousemove = null
    slide.onclick = function (e) {
      if (e) e.stopPropagation()
      selectSolution(index)
    }
  })
  syncThumbActive(top.activeIndex || 0)

  try {
    if (thumbs && thumbs.update) thumbs.update()
    if (top && top.update) top.update()
  } catch (e) { /* noop */ }

  return { thumbs, top }
}
